import Head from 'next/head';
import { NavBar } from 'components/shared/NavBar';
import Link from 'next/link';

const Page = () => {
	return (
		<>
			<Head>
				<title>Impressum | Siccro Active Service</title>
				<meta
					name="description"
					content="Gereinigte Fenster sind eine gute Basis für ein angenehmes Wohnumfeld. Experten von SICCRO empfehlen, zusätzlich einige Pflegemaßnahmen durchzuführen, weil diese sich positiv auf die Lebensdauer auswirken und Ihnen dadurch Kosten sparen."
				/>
			</Head>
			<NavBar />
			<div className="mt-28 container text-4xl text-center md:pt-12 font-black  md:text-5xl mx-auto">
				<h2>Impressum</h2>
			</div>
			<div className=" max-w-[900px] text-xl pt-10 px-30 text-left flex flex-col mx-auto">
				<p>
					Informationspflicht laut §5 E‑Commerce Gesetz, §14 Unternehmensgesetzbuch, §63 Gewerbeordnung und
					Offenlegungspflicht laut §25 Mediengesetz.
					<br />
					<br />
					SYMAK Austria GmbH
					<br />
					Salzburger Straße 26, OG3,
					<br />
					5204 Straßwalchen,
					<br />
					Österreich
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black"> Unternehmensgegenstand:</h3>
				<p>
					System- und Softwareentwicklung für Vertriebssysteme
					<br />
					Vergabe von Lizenzrechten für Vertriebssysteme
					<br />
					<br />
					<b> UID-Nummer:</b> ATU76446909
					<br />
					<br />
					<b>Firmenbuchnummer:</b> FN 549059 s
					<br />
					<b>Firmenbuchgericht:</b> Landesgericht Salzburg
					<br />
					<b>Firmensitz:</b> Straßwalchen
					<br />
					<b>Tel.:</b> +43 662 27 55 00
					<br />
					<b>E‑Mail:</b>office@symak.at
					<br />
					<b>Berufsrecht:</b> Gewerbeordnung: www.ris.bka.gv.at
					<br />
					<b>Aufsichtsbehörde/Gewerbebehörde:</b>
					Bezirkshauptmannschaft Salzburg-Umgebung
					<br />
					<b>Verleihungsstaat:</b>Österreich
					<br />
					<b>Geschäftsführer</b> Penias Josef
					<br />
					<b>Beteiligungsverhältnisse</b> Firma SYMAK SWISS AG AG Anteil: 100,00%
					<br />
					<br />
					Quelle: Erstellt mit dem Impressum Generator von AdSimple
					<br />
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black"> EU-Streitschlichtung</h3>
				<p>
					Gemäß Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten (ODR-Verordnung) möchten
					wir Sie über die Online-Streitbeilegungsplattform (OS-Plattform) informieren.Verbraucher haben die
					Möglichkeit, Beschwerden an die Online Streitbeilegungsplattform der Europäischen Kommission unter
					http://ec.europa.eu/odr?tid=121726994 zu richten. Die dafür notwendigen Kontaktdaten finden Sie
					oberhalb in unserem Impressum.
					<br />
					<br />
					Wir möchten Sie jedoch darauf hinweisen, dass wir nicht bereit oder verpflichtet sind, an
					Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black"> Haftung für Inhalte dieser Website</h3>
				<p>
					Wir entwickeln die Inhalte dieser Webseite ständig weiter und bemühen uns korrekte und aktuelle
					Informationen bereitzustellen. Leider können wir keine Haftung für die Korrektheit aller Inhalte auf
					dieser Website übernehmen, speziell für jene, die seitens Dritter bereitgestellt wurden. Als
					Diensteanbieter sind wir nicht verpflichtet, die von ihnen übermittelten oder gespeicherten
					Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
					hinweisen.
					<br />
					<br />
					Unsere Verpflichtungen zur Entfernung von Informationen oder zur Sperrung der Nutzung von
					Informationen nach den allgemeinen Gesetzen aufgrund von gerichtlichen oder behördlichen Anordnungen
					bleiben auch im Falle unserer Nichtverantwortlichkeit davon unberührt. Sollten Ihnen problematische
					oder rechtswidrige Inhalte auffallen, bitte wir Sie uns umgehend zu kontaktieren, damit wir die
					rechtswidrigen Inhalte entfernen können. Sie finden die Kontaktdaten im Impressum.
					<br />
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Haftung für Links auf dieser Webseite</h3>
				<p>
					Unsere Webseite enthält Links zu anderen Webseiten für deren Inhalt wir nicht verantwortlich sind.
					Haftung für verlinkte Websites besteht für uns nicht, da wir keine Kenntnis rechtswidriger
					Tätigkeiten hatten und haben, uns solche Rechtswidrigkeiten auch bisher nicht aufgefallen sind und
					wir Links sofort entfernen würden, wenn uns Rechtswidrigkeiten bekannt werden.
					<br />
					<br />
					Wenn Ihnen rechtswidrige Links auf unserer Website auffallen, bitte wir Sie uns zu kontaktieren. Sie
					finden die Kontaktdaten im Impressum.
					<br />
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Urheberrechtshinweis</h3>
				<p>
					Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen dem Urheberrecht. Bitte
					fragen Sie uns bevor Sie die Inhalte dieser Website verbreiten, vervielfältigen oder verwerten wie
					zum Beispiel auf anderen Websites erneut veröffentlichen. Falls notwendig, werden wir die unerlaubte
					Nutzung von Teilen der Inhalte unserer Seite rechtlich verfolgen. Sollten Sie auf dieser Webseite
					Inhalte finden, die das Urheberrecht verletzen, bitten wir Sie uns zu kontaktieren.
					<br />
					<br />
					<br />
				</p>
				<h3 className="text-2xl py-5 font-black">Bildernachweis</h3>
				<p>
					Die Bilder, Fotos und Grafiken auf dieser Webseite sind urheberrechtlich geschützt. Die Bilderrechte
					liegen bei den folgenden Fotografen und Unternehmen:
					<br />
					<br />
					<b>Symak Austria</b>
					<br />
					<br />
					<br />
				</p>
			</div>
		</>
	);
};

export default Page;
